export function getColoredMeterSVG(innerColor) {
  const svg = `
    <svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <!-- Outer Ring -->
      <circle cx="50" cy="50" r="45" fill="beige" stroke="#ccc" stroke-width="5"/>
      
      <!-- Inner Circle - picks the dynamic color -->
      <circle cx="50" cy="50" r="40" fill="${innerColor}" />

      <!-- Dial Needle pointing at 60 degrees -->
      <line x1="50" y1="50" x2="${50 + 30 * Math.cos(Math.PI / 3)}" y2="${50 - 30 * Math.sin(Math.PI / 3)}" stroke="#fff" stroke-width="5" stroke-linecap="round" />
    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export function getTankSVG(innerColor) {
  const svg = `
    <svg width="22" height="22" viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
      <!-- Top arc (rounded top) -->
      <ellipse cx="50" cy="30" rx="25" ry="8" fill="beige"/>

      <!-- Tank base (cylinder body) -->
      <rect x="25" y="30" width="50" height="60" rx="10" fill="${innerColor}" stroke="beige" stroke-width="6"/>

      <!-- Bottom arc (rounded bottom) -->
      <ellipse cx="50" cy="90" rx="25" ry="8" fill="beige"/>

      <!-- Support legs -->
      <line x1="30" y1="90" x2="30" y2="110" stroke="beige" stroke-width="4"/>
      <line x1="70" y1="90" x2="70" y2="110" stroke="beige" stroke-width="4"/>
    </svg>
  `.trim();
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}


export function getTreatmentWorksSVG(innerColor) {
  const svg = `
    <svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="35" fill="${innerColor}" stroke="beige" stroke-width="10" />
      <circle cx="50" cy="50" r="10" fill="white" />
    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export function getBulkMeterSVG(innerColor) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 100 100">
      <!-- Outer Ring (Fixed color) -->
      <circle cx="50" cy="50" r="45" fill="gray" stroke="#d6cfc1" stroke-width="5" />

      <!-- Inner Circle (Dynamic color) -->
      <circle cx="50" cy="50" r="25" fill="${innerColor}" />

      <!-- Pointer (Fixed color) -->
      <polygon points="50,10 55,25 45,25" fill="#d6cfc1" />
    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export function getControlValveSVG(innerColor) {
  const svg = `
    <svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="35" fill="brown" stroke="#ccc" stroke-width="5"/>
      <line x1="20" y1="50" x2="80" y2="50" stroke="${innerColor}" stroke-width="10"/>
      <line x1="50" y1="20" x2="50" y2="80" stroke="${innerColor}" stroke-width="10"/>
    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export function getOfftakeSVG(innerColor) {
  const svg = `
    <svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <!-- Main horizontal pipe -->
      <rect x="10" y="40" width="80" height="12" rx="6" fill="orange" />

      <!-- Branch pipe (offtake) -->
      <rect x="44" y="10" width="12" height="30" rx="6" fill="orange" />

      <!-- Junction (colored part) -->
      <circle cx="50" cy="45" r="16" fill="${innerColor}" stroke="black" stroke-width="2"/>
    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}


export function getBoreholeSVG(innerColor) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 100 100">
    <!-- Outer ring and arrow (fixed color) -->
    <circle cx="50" cy="50" r="45" fill="none" stroke="blue" stroke-width="10" />
    <path d="M50 10 L55 25 L45 25 Z" fill="#e0d6c5" transform="rotate(45, 50, 50)" />

    <!-- Inner circle (dynamic color) -->
    <circle cx="50" cy="50" r="30" fill="${innerColor}" />
  </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}


export function getWeirSVG(innerColor) {
  const svg = `
    <svg width="24" height="24" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <polygon points="20,70 80,30 80,70" fill="${innerColor}"/>
      <rect x="20" y="70" width="60" height="10" fill="orange" />
    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export function getIncidentSVG(innerColor) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 100 100">
      
      <!-- Outer Ring (consistent with other icons) -->
      <circle cx="50" cy="50" r="45" fill="#5a5a5a" stroke="#d6cfc1" stroke-width="5"/>

      <!-- Inner Circle (dynamic status color) -->
      <circle cx="50" cy="50" r="28" fill="${innerColor}" />

      <!-- Burst/Crack Symbol -->
      <path d="M30 50 L45 45 L40 60 L55 55 L50 70 L65 60"
            stroke="#ffffff"
            stroke-width="3"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"/>

      <!-- Exclamation Mark -->
      <line x1="50" y1="30" x2="50" y2="55" stroke="#ffffff" stroke-width="5" stroke-linecap="round"/>
      <circle cx="50" cy="68" r="4" fill="#ffffff"/>

    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}
